import React from 'react';
const Loader = () => {
  return (
    <div className="loadingScreen">
      <img src="/media/loader1.svg" className="w-3" />
    </div>
  );
};

export default Loader;